// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".component-function .btn-box[data-v-7e14923d] {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
